// These must be the first lines in src/index.js
// import 'react-app-polyfill/ie9';
// import 'react-app-polyfill/stable';
import React from 'react';
import '@babel/polyfill';
import ReactDOM from 'react-dom';
import {
  HttpLink,
  InMemoryCache,
  ApolloClient,
  ApolloProvider,
  defaultDataIdFromObject
} from '@apollo/client';
// import '@fontsource/open-sans';
// import './index.css';
// import App from './App';
import KinhThanhRouter from './js/KinhThanhRouter';
import * as serviceWorker from './serviceWorker';

// const httpLink = new HttpLink({
//   uri: 'http://thuvientinlanh.com/tvtlbible/',
// });
const tvClient = new ApolloClient({
  cache: new InMemoryCache({
    dataIdFromObject: object => {
      switch (object.__typename) {
        case 'Verse':
          return object.id.concat(object.text); // use text as uniq
        //TODO generate uniq key for verse beside id
        default:
          return defaultDataIdFromObject(object); // fall back to default handling
      }
    }
  }),
  link: new HttpLink({
    uri: 'https://thuvientinlanh.org/tvtlbible/'
    // uri: 'http://localhost:4000/tvtlbible'
  })
});
ReactDOM.render(
  <ApolloProvider client={tvClient}>
    <KinhThanhRouter />
  </ApolloProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
